import Vue from 'vue'
import { Toast, ImagePreview } from 'vant'
import html2canvas from 'html2canvas'

export default{
  utils () {
    Vue.prototype.pr = function (path) {
      this.$router.push(path)
    },
    //  加载符
    Vue.prototype.showLoading = function (mes) {
      Toast.loading({
        mask: true,
        message: mes || '加载中',
        duration: 0
      })
      return this
    },
    //  提示符
    Vue.prototype.showToast = function (mes) {
      Toast({
        message: mes,
        duration: 1000,
        overlay: true
      })
      return this
    },
    //  时间转换
    Vue.prototype.formDate = function (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      m <= 9 ? m = '0' + m : ''
      d <= 9 ? d = '0' + d : ''
      return y + '-' + m + '-' + d
    },
    //  时间区间校验
    Vue.prototype.timeRange = function (beginTime, endTime) {
      var strb = beginTime.split(':')
      if (strb.length != 2) {
        return false
      }
      var stre = endTime.split(':')
      if (stre.length != 2) {
        return false
      }

      var b = new Date()
      var e = new Date()
      var n = new Date()

      b.setHours(strb[0])
      b.setMinutes(strb[1])
      e.setHours(stre[0])
      e.setMinutes(stre[1])

      if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
        return true
      } else {
        return false
      }
    },
    //  图片预览
    Vue.prototype.previewImg = function (image, index) {
      if (typeof (image) === 'string') {
        image = [image]
      }
      console.log(image)
      ImagePreview({
        images: image,
        startPosition: index || 0
      })
    },
    //  base64转blob
    Vue.prototype.dataURLtoBlob = function (dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //  机票火车票时间列表
    Vue.prototype.getNeardate = function (date) {
      let week = ['日', '一', '二', '三', '四', '五', '六']
      let arr = []
      let current = new Date(date.replace(/-/g, '/'))
      let begin = new Date(current.getFullYear(), current.getMonth(), current.getDate() - 4)
      let now = new Date(new Date(new Date().toLocaleDateString()).getTime())
      let active = 4
      // console.log(current)
      for (let i = 0; i < 14; i++) {
        let time = new Date(begin.getFullYear(), begin.getMonth(), begin.getDate() + i)
        // console.log(time)
        if (time < now) {
          active -= 1
        } else {
          // console.log(time + ':'+ i)
          let m = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
          let d = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
          let weekday = week[time.getDay()]
          let obj = {
            y: time.getFullYear(),
            m: m,
            d: d,
            week: weekday,
            date: time.getFullYear() + '-' + m + '-' + d
          }
          arr.push(obj)
        }
        if (i === 13) {
          let obj = {
            'arr': arr,
            'active': active
          }
          return obj
        }
      }
    },
    //  校验手机号{
    Vue.prototype.checktel = function (val) {
      if (!val || val == '') {
        this.showToast('请输入手机号')
        return false
      }
      if (/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(val) || /^((0\d{2,3}-?\d{7,8})|(1[3584]\d{9}))$/.test(val)) {
        return true
      } else {
        this.showToast('手机号格式不正确')
        return false
      }
    },
    //  校验必填
    Vue.prototype.validate = function (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (!arr[i].val && arr[i].val !== 0) {
          this.showToast(arr[i].tips)
          return false
        }
      }
      return true
    },
    //  校验身份证号码
    Vue.prototype.checkIdcard = function (value) {
      if (value.length == 18 && /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
        return true
      } else {
        this.showToast('身份证号码有误')
        return false
      }
    },
      //  校验银行卡号
      Vue.prototype.checkBankcard = function (value) {
        if (value.length == 18 && /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
          return true
        } else {
          this.showToast('银行卡号有误')
          return false
        }
      },
    //  校验密码，密码长度6位以上,只能输入数字，字母或下划线
    Vue.prototype.checkPwd = function (value) {
      if (/^[0-9a-zA-Z_]{6,}$/.test(value)) {
        return true
      } else {
        this.showToast('密码格式错误')
        return false
      }
    },
    // //  校验密码，密码长度6-16位,只能输入数字，字母或下划线
    // Vue.prototype.checkPwd = function (value) {
    //   if (/^[0-9a-zA-Z_]{6,16}$/.test(value)) {
    //     return true
    //   } else {
    //     this.showToast('密码格式错误')
    //     return false
    //   }
    // },
    //  图片合成
    Vue.prototype.htmlToImg = function (obj) {
      return new Promise((resolve, reject) => {
        const opts = {
          useCORS: true,
          tainttest: true,
          allowTaint: false,
          scale: 4,
        }
        html2canvas(obj, opts).then(function (canvas) {
          let url = canvas.toDataURL('image/jpeg');
          resolve(url)
        });
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js